export default __webpack_public_path__ + "static/media/ScrollTwo.4b1ce199.png";